import type { SupportedLocale } from '@lark-automadoc/shared-types'
import en from './en.json'
import zh from './zh.json'
import id from './id.json'
import es from './es.json'
import vi from './vi.json'
import th from './th.json'
import ja from './ja.json'

export { en, zh, id, es, vi, th, ja }

/** Display metadata for each supported locale */
export const LOCALE_META: Record<SupportedLocale, { name: string; flag: string }> = {
  en: { name: 'English', flag: '🇺🇸' },
  zh: { name: '中文', flag: '🇨🇳' },
  id: { name: 'Indonesia', flag: '🇮🇩' },
  es: { name: 'Español', flag: '🇪🇸' },
  vi: { name: 'Tiếng Việt', flag: '🇻🇳' },
  th: { name: 'ไทย', flag: '🇹🇭' },
  ja: { name: '日本語', flag: '🇯🇵' },
}

/** All locale messages indexed by locale code */
const allMessages: Record<SupportedLocale, typeof en> = { en, zh, id, es, vi, th, ja }

/** Get the message object for a given locale (falls back to English) */
export function getMessages(locale: SupportedLocale): typeof en {
  return allMessages[locale] || allMessages.en
}
